interface PagingProps {
  pageSize: number;
  currentPage: number;
  recordCount: number;
  onPageChange: (page: number) => void;
}

const PayoutsTablePaging = ({ pageSize, currentPage, recordCount, onPageChange }: PagingProps) => {
  const totalPages = Math.ceil(recordCount / pageSize);

  return (
    <div className="d-flex justify-content-between align-items-center mt-2">
      <span className="text-muted small">
        {recordCount} registros — página {currentPage} de {totalPages}
      </span>
      <div className="d-flex gap-1">
        {totalPages >= 10 && (
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={currentPage <= 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            ‹
          </button>
        )}
        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter(p => Math.abs(p - currentPage) <= 2)
          .map(p => (
            <button
              key={p}
              className={`btn btn-sm ${p === currentPage ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          ))}
        {totalPages >= 10 && (
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={currentPage >= totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            ›
          </button>
        )}
      </div>
    </div>
  );
};

export default PayoutsTablePaging;